import { fromJS, Map, List } from "immutable";
import snakeCase from "lodash/snakeCase";
import { plural } from "pluralize";
import * as actionTypes from "~/store/action_types";

const initialState = Map({
  projects: List([]),
  teams: List([]),
});

const favorites = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ANGULAR_INIT: {
      const { response = {} } = action;
      const { favorites = [] } = response;

      if (favorites.length) {
        const collection = favorites.reduce((groups, item) => {
          const parentType = item.parent_type ? snakeCase(plural(item.parent_type)) : null;
          const parentId = item.parent_id ? item.parent_id : 0;
          if (parentType && parentId > 0) {
            const group = groups[parentType] || [];
            group.push(parentId);
            groups[parentType] = group;
            return groups;
          }
        }, {});
        return state.merge(initialState, fromJS(collection));
      }

      return state;
    }
    case actionTypes.REMOVE_FAVORITE_ERROR:
    case actionTypes.ADD_FAVORITE_LOADING:
    case actionTypes.ADD_FAVORITE_SUCCESS: {
      const { parentType: type = "", parentId = 0 } = action;
      const parentType = type ? snakeCase(plural(type)) : null;

      let collection = state.get(parentType, List([]));

      if (parentType && parentId > 0) {
        collection = !collection.includes(parentId) ? collection.push(parentId) : collection;
        state = state.set(parentType, collection);
      }
      return state;
    }
    case actionTypes.ADD_FAVORITE_ERROR:
    case actionTypes.REMOVE_FAVORITE_LOADING:
    case actionTypes.REMOVE_FAVORITE_SUCCESS: {
      const { parentType: type = "", parentId = 0 } = action;
      const parentType = type ? snakeCase(plural(type)) : null;

      let collection = state.get(parentType, List([]));

      if (collection.includes(parentId)) {
        collection = collection.remove(collection.indexOf(parentId));
        state = state.set(parentType, collection);
      }
      return state;
    }
    default:
      return state;
  }
};

export default favorites;
